import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import specializedImg from "../../../../assets/imgs/services/international/specialized.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

import specializedLogo from "../../../../assets/imgs/services/international/specialized.svg";
import specializedCover from "../../../../assets/imgs/services/international/specialized.jpg";
import phoneIcon from "../../../../assets/imgs/services/international/telephone-icon.svg";
import { useQuill } from "react-quilljs";
import '../general/general.css'
import { Link } from "react-router-dom";
import { normalizeInternationalQuillContent } from "../shared/normalize-international-quill";

function Specialized() {
  const [tSpecialized] = useTranslation("specializedPage");
  const [tSMetaData] = useTranslation("metaData");
  const idSpecialized = "fa1b236b-b81e-47b0-87e8-960dde11a627";
  const [textDescription, setTextDescription] = useState("");

  const {quill, quillRef} = useQuill({
      readOnly: true,
      modules: {toolbar: false}
    });
  
    useEffect(() => {
      // Solo ejecuta si quill existe Y textDescription tiene contenido
      if (quill && textDescription) {
        try {
          const content = JSON.parse(
            normalizeInternationalQuillContent(textDescription)
          );
          quill.setContents(content);
        } catch (e) {
          console.error("Error al parsear el contenido de Quill:", e);
        }
      }
    }, [textDescription, quill]);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["products-internacional-submenu"])[2]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["products-international-submenu"])[2]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idSpecialized}`
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("specialized.title")}</title>
        <meta
          name="description"
          content={tSMetaData("specialized.description")}
        />
      </Helmet>
      {/* <ImageHeader
        section={tSpecialized("header.section")}
        title={tSpecialized("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tSpecialized("description.content"))
        }
        contactSales={tSpecialized("header.contact-sales")}
        contactProductID="btnContactSpecialized"
        imgBackground={specializedImg}
      /> */}
      <div className="container-fluid international-service-container">
        <div className="row">
          <div className="col-lg-4 border p-0"> 
            <img 
              src={specializedCover} 
              alt="General Service"
              className="img-service-cover"
            />
          </div>
          <div className="col-lg-8 border international-product-text">
            <img className="service-international-logo" src={specializedLogo} />
            <div>
              <div ref={quillRef}></div>
            </div>
            {/* <p className="mt-4 international-first-title">DESCRIPCIÓN</p>
            <p>
              Confianza y seguridad sin igual cuando para su embarque el tiempo es apremiante. 
              Manténgase tranquilo sabiendo que su carga será entregada de la manera más rápida 
              y segura. Desde la reserva hasta su entrega, su embarque GOLD es manejado con 
              sumo cuidado, con selección de vuelo, vuelo de respaldo, alta prioridad en abordaje 
              y las conexiones más rápidas.
            </p>
            <p className="international-first-title">CARACTERÍSTICAS Y BENEFICIOS</p>
            <ul>
              <li>Para embarques que son transportados en un vuelo específico.</li>
              <li>Prioridad en el abordaje y pronta entrega en el aeropuerto de destino.</li>
              <li>Asignación de vuelo al momento de la documentación.</li>
              <li>Aplica sólo en mercancía general.</li>
            </ul> */}
            <Link to={tSpecialized("link-contact")} className="btn-contact-seller">
              <img src={phoneIcon} />
              <span>{tSpecialized("header.contact-sales")}</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Specialized;
